import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Spinner } from '../components/ui';

export function ProtectedRoute() {
  const { status } = useAuth();
  if (status === 'loading') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Spinner label="正在恢复登录会话…" />
      </div>
    );
  }
  if (status === 'anon') return <Navigate to="/login" replace />;
  return <Outlet />;
}
